import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import HowToBuy from "../views/HowToBuy.vue"
import MiniGame from "../views/MiniGame.vue"

Vue.use(VueRouter);

// Lazy-load wallet pages so @web3-onboard/vue only runs when user visits them
// (avoids "Cannot read properties of undefined (reading 'length')" on home page)
const BuyNFT = () => import(/* webpackChunkName: "buy-nft" */ "../views/BuyNFT.vue");
const MyNFT = () => import(/* webpackChunkName: "my-nft" */ "../views/MyNFT.vue");

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/how-to-buy",
    name: "HowToBuy",
    component: HowToBuy,
  },
  {
    path: "/buy-nft",
    name: "BuyNFT",
    component: BuyNFT,
  },
  {
    path: "/my-nft",
    name: "MyNFT",
    component: MyNFT,
  },
  {
    path: "/minigame",
    name: "MiniGame",
    component: MiniGame,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
